import { render } from "./AddAccess.vue?vue&type=template&id=0257195a"
import script from "./AddAccess.vue?vue&type=script&lang=js"
export * from "./AddAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__